import { BaseItemsStylesRenderer } from "./base-items-styles-renderer";

export class DefaultItemsStyleRenderer extends BaseItemsStylesRenderer {

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public getStyleSpecificSelectors(id: string): Array<string> {
        return [];
    }

}
